/* eslint-disable no-undef */
export default {
  methods: {
    getAllScripts () {

    }
  }
}
